import Reactotron from 'reactotron-react-js'
import { reactotronRedux } from 'reactotron-redux'

const tron: any = { createEnhancer: () => null }

const reactotronEnabled = process.env.REACT_APP_TRON_ENABLED === 'true'

if (process.env.NODE_ENV !== 'production' && reactotronEnabled) {
  const _tron = Reactotron.configure().use(reactotronRedux()).connect()
  _tron.clear()
  Object.assign(tron, _tron)
}

export default tron
